function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef, useState, useEffect } from 'react';
import { useTable, useResizeColumns, useBlockLayout, useSortBy } from 'react-table';
import { useSelector, useDispatch } from 'react-redux';
import { sortedArray } from '../../../utils/utils';
import { RecommendationChip } from './RecommendationChip';
import { pushChipArray, pushSearchChipArray } from '../../../slices/RiskFilterSlice';
import { Checkbox } from '@material-ui/core';
import sortDown from '../../../assets/img/sortdown.svg';
import sortUp from '../../../assets/img/sortup.svg';
import Flag from '../../../assets/img/Flag.svg';
import unflag from '../../../assets/img/unflag.svg';
import TableRiskIndicator from '../../TableRiskIndicator/TableRiskIndicator';
import Tooltip from '@material-ui/core/Tooltip';

const headerProps = (props, {
  column
}) => getStyles(props, column.align);

const cellProps = (props, {
  cell
}) => getStyles(props, cell.column.align);

const getStyles = (props, align) => [props, {
  style: {
    justifyContent: align === 'center' ? 'center' : 'flex-start',
    alignItems: 'center',
    display: 'flex'
  }
}];

const TableFunction = ({
  columns,
  data,
  handleRequestSort,
  handleSetriskTableSortString,
  sortOrder,
  sortOrderBy,
  handleViewDetail,
  checkListArray,
  handleSelectedWatchFlag,
  handleRecoEnvSortString,
  searchResponse,
  isRiskTable,
  handleTableRowClick,
  isTreemapApplication
}) => {
  const tableRef = useRef(null);
  const [tableWidth, setTableWidth] = useState();
  const [updatedColumns, setUpdatedColumns] = useState(columns);
  const tabFlag = useSelector(state => state.buttonSlice.tabFlag);
  const showCard = useSelector(state => state.riskFilterSlice.showCard);
  const envClickEvent = useSelector(state => state.applicationDrillHeatMap.envClickEvent);
  const selectedType = useSelector(state => state.riskFilterSlice.type);
  const dispatch = useDispatch();
  const defaultColumn = React.useMemo(() => ({
    minWidth: 50
  }), []);
  useEffect(() => {
    if (tableRef.current) {
      setTableWidth(tableRef.current.parentElement.offsetWidth);
    }
  }, [tableRef]);
  useEffect(() => {
    const setColumnWidths = () => {
      let totalColumnWidth = 0;
      const filteredColumns = columns.filter(column => !column.hidden);
      filteredColumns.forEach(column => totalColumnWidth += column.width);

      if (tableWidth > totalColumnWidth) {
        setUpdatedColumns(filteredColumns.map(column => ({ ...column,
          width: column.width / totalColumnWidth * tableWidth
        })));
      } else {
        setUpdatedColumns(filteredColumns);
      }
    };

    setColumnWidths();
  }, [tableWidth, columns]);
  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns: updatedColumns,
    data,
    defaultColumn
  }, useResizeColumns, useBlockLayout, useSortBy);

  const handleSortBy = sortColumn => {
    if (tabFlag) {
      if (tabFlag && envClickEvent) {
        handleRecoEnvSortString(sortColumn.id);
      } else {
        handleSetriskTableSortString(sortColumn.id);
      }
    } else {
      handleRequestSort(sortColumn.id);
    }
  };

  const toolTip = (type, cell) => {
    return type === 'risk' ? /*#__PURE__*/React.createElement(Tooltip, {
      key: cell.render('Cell'),
      title: cell.render('Cell'),
      arrow: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "ellipsis"
    }, cell.render(TableRiskIndicator(cell.value)))) : /*#__PURE__*/React.createElement(Tooltip, {
      key: cell.render('Cell'),
      title: cell.render('Cell'),
      arrow: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "ellipsis"
    }, cell.render('Cell')));
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, getTableProps(), {
    className: "table",
    ref: tableRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "thead"
  }, headerGroups.map((headerGroup, index) => /*#__PURE__*/React.createElement("div", _extends({
    key: index
  }, headerGroup.getHeaderGroupProps({}), {
    className: "tr"
  }), headerGroup.headers.map((column, index) => /*#__PURE__*/React.createElement("div", _extends({
    key: index
  }, column.getHeaderProps(headerProps), {
    className: "th",
    onClick: () => {
      {
        column['Header'] != '' && column['Header'] !== 'Recommendation' ? handleSortBy(column) : null;
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "headerName"
  }, column.render('Header')), column.Header !== '' && column.id === sortOrderBy ? /*#__PURE__*/React.createElement("span", {
    className: "sortingIconSpan"
  }, sortOrder === 'ASC' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: sortUp
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: sortDown
  }))) : null, column.canResize && /*#__PURE__*/React.createElement("div", _extends({}, column.getResizerProps(), {
    className: `resizer ${column.isResizing ? 'isResizing' : ''}`,
    onClick: e => {
      e.stopPropagation();
    }
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "tbody"
  }, rows.map((row, index) => {
    const isItemSelected = row.original.checked;
    const labelId = `enhanced-table-checkbox-${index}`;
    prepareRow(row);
    return /*#__PURE__*/React.createElement("div", _extends({
      key: index
    }, row.getRowProps(), {
      className: "tr"
    }), /*#__PURE__*/React.createElement(React.Fragment, null, showCard ? /*#__PURE__*/React.createElement(Checkbox, {
      checked: isItemSelected,
      color: "primary",
      onChange: event => {
        let entityKeyName = selectedType && selectedType.keyName;

        if (checkListArray && checkListArray.length > 0) {
          let uncheckedItems = '';

          switch (entityKeyName) {
            case 'Application Name':
              {
                uncheckedItems = checkListArray.filter(checkListItem => {
                  return row.original.Application_Name !== checkListItem.Application_Name;
                });
                uncheckedItems.push({
                  id: row.original.id,
                  Application_Name: row.original.Application_Name,
                  checked: event.target.checked
                });
                break;
              }

            case 'Application Type':
              {
                uncheckedItems = checkListArray.filter(checkListItem => {
                  return row.original.Application_Type !== checkListItem.Application_Type;
                });
                uncheckedItems.push({
                  id: row.original.id,
                  Application_Type: row.original.Application_Type,
                  checked: event.target.checked
                });
                break;
              }

            case 'Environment Name':
              {
                uncheckedItems = checkListArray.filter(checkListItem => {
                  return row.original.Environment_Name !== checkListItem.Environment_Name;
                });
                uncheckedItems.push({
                  id: row.original.id,
                  Environment_Name: row.original.Environment_Name,
                  checked: event.target.checked
                });
                break;
              }

            case 'Entity Type':
              {
                uncheckedItems = checkListArray.filter(checkListItem => {
                  return row.original.Entity_Type !== checkListItem.Entity_Type;
                });
                uncheckedItems.push({
                  id: row.original.id,
                  Entity_Type: row.original.Entity_Type,
                  checked: event.target.checked
                });
                break;
              }

            case 'Entity Name':
              {
                uncheckedItems = checkListArray.filter(checkListItem => {
                  return row.original.Entity_Name !== checkListItem.Entity_Name;
                });
                uncheckedItems.push({
                  id: row.original.id,
                  Entity_Name: row.original.Entity_Name,
                  checked: event.target.checked
                });
                break;
              }

            default:
              break;
          }

          dispatch(pushChipArray(sortedArray(uncheckedItems)));
        }

        if (checkListArray && checkListArray.length > 0) {
          let uncheckedSearchItems = '';

          switch (entityKeyName) {
            case 'Application Name':
              {
                uncheckedSearchItems = searchResponse.filter(checkListItem => {
                  return row.original.Application_Name !== checkListItem.Application_Name;
                });
                uncheckedSearchItems.push({
                  id: row.original.id,
                  Application_Name: row.original.Application_Name,
                  checked: event.target.checked
                });
                break;
              }

            case 'Application Type':
              {
                uncheckedSearchItems = searchResponse.filter(checkListItem => {
                  return row.original.Application_Type !== checkListItem.Application_Type;
                });
                uncheckedSearchItems.push({
                  id: row.original.id,
                  Application_Type: row.original.Application_Type,
                  checked: event.target.checked
                });
                break;
              }

            case 'Environment Name':
              {
                uncheckedSearchItems = searchResponse.filter(checkListItem => {
                  return row.original.Environment_Name !== checkListItem.Environment_Name;
                });
                uncheckedSearchItems.push({
                  id: row.original.id,
                  Environment_Name: row.original.Environment_Name,
                  checked: event.target.checked
                });
                break;
              }

            case 'Entity Type':
              {
                uncheckedSearchItems = searchResponse.filter(checkListItem => {
                  return row.original.Entity_Type !== checkListItem.Entity_Type;
                });
                uncheckedSearchItems.push({
                  id: row.original.id,
                  Entity_Type: row.original.Entity_Type,
                  checked: event.target.checked
                });
                break;
              }

            case 'Entity Name':
              {
                uncheckedSearchItems = searchResponse.filter(checkListItem => {
                  return row.original.Entity_Name !== checkListItem.Entity_Name;
                });
                uncheckedSearchItems.push({
                  id: row.original.id,
                  Entity_Name: row.original.Entity_Name,
                  checked: event.target.checked
                });
                break;
              }

            default:
              break;
          }

          dispatch(pushSearchChipArray(sortedArray(uncheckedSearchItems)));
        }
      },
      inputProps: {
        'aria-labelledby': {
          labelId
        }
      }
    }) : null, row.cells.map((cell, index) => {
      return /*#__PURE__*/React.createElement("div", _extends({
        key: index
      }, cell.getCellProps(cellProps), {
        className: "td",
        onClick: event => {
          if (!tabFlag || envClickEvent) {
            if (cell.column.Header === '') {
              handleSelectedWatchFlag(event, cell);
            } else {
              if (!showCard) {
                handleViewDetail(cell);
              }
            }
          } else if (isRiskTable) {
            handleTableRowClick(isTreemapApplication ? cell.row.original.envName : cell.row.original.origin);
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "ellipsis"
      }, cell.column.Header === '' ? cell.value === 0 ? cell.render( /*#__PURE__*/React.createElement("img", {
        src: unflag
      })) : cell.render( /*#__PURE__*/React.createElement("img", {
        src: Flag
      })) : cell.column.Header === 'Recommendation' ? cell.render(RecommendationChip(cell.row.original)) : cell.column.Header === 'Application Risk Category' || cell.column.Header === 'Entity Risk Category' || cell.column.Header === 'Environment Risk Category' ? toolTip('risk', cell) : toolTip('row', cell)));
    })));
  })));
};

export default TableFunction;